import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {AppRoutingModule} from './app-routing.module';
import {NavigationComponent} from './navigation/navigation.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HelpModule} from './help/help.module';
import {DndModule} from 'ng2-dnd';
import {StoryboardListModule} from './storyboard/storyboard-list/storyboard-list.module';
import {StoryboardEditModule} from './storyboard/storyboard-edit/storyboard-edit.module';
import {MomentModule} from 'angular2-moment';
import {HttpInterceptorModule} from 'ng-http-interceptor';
import {AuthGuard} from './auth/auth.guard';
import {AuthModule} from './auth/auth.module';
//import {BugsnagErrorHandler} from './bugsnag/bugsnag-error-handler';
//import {BugsnagModule} from './bugsnag/bugsnag.module';
import {TemplateEditModule} from './template/template-edit/template-edit.module';
import {TemplateListModule} from './template/template-list/template-list.module';
import {WindowRef} from './shared/WindowRef';
import {StoryboardPublishModule} from './storyboard-publish/storyboard-publish.module';
import {DragService} from "./storyboard/shared/drag.service";
import {StoryboardService} from "./storyboard/shared/storyboard.service";
import {TemplateService} from "./template/shared/template.service";
import {TimelineService} from "./storyboard/storyboard-edit/timeline/timeline.service";
import {StoryboardRendererAudioService} from "app/storyboard/storyboard-edit/preview/preview-render-component/storyboard-renderer-audio.service";
import {FontService} from "./storyboard/storyboard-edit/shared/font.service";
import { CorporateUiHeaderComponent } from './corporate-ui-header/corporate-ui-header.component';
import { CorporateUiFooterComponent } from './corporate-ui-footer/corporate-ui-footer.component';
import {AlertService} from "./shared/alert/alert.service";
import {AlertComponent} from "./shared/alert/alert.component";
import {LocalStorageModule} from "angular-2-local-storage";
import {HotkeyModule} from 'angular2-hotkeys';
import {TemplateFolderShareService} from "./template/shared/template-folder-share.service";
import {TemplateFolderSubscriptionService} from "./template/shared/template-folder-subscription.service";
import {TimeTrackingService} from "./storyboard/shared/time-tracking.service";
import {HttpClient, HttpClientModule} from "@angular/common/http";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    NavigationComponent,
    CorporateUiHeaderComponent,
    CorporateUiFooterComponent,
    AlertComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpInterceptorModule,
    MomentModule,
    NgbModule.forRoot(),
    DndModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    LocalStorageModule.withConfig({
      prefix: 'storyboard',
      storageType: 'localStorage'
    }),
    AuthModule,
    //BugsnagModule,
    StoryboardListModule,
    StoryboardEditModule,
    StoryboardPublishModule,
    TemplateEditModule,
    TemplateListModule,
    HelpModule,
    AppRoutingModule,
    HotkeyModule.forRoot()
  ],
  providers: [
    AuthGuard,
    WindowRef,
    //BugsnagErrorHandler,
    DragService,
    StoryboardService,
    TemplateService,
    TemplateFolderShareService,
    TemplateFolderSubscriptionService,
    TimelineService,
    TimeTrackingService,
    FontService,
    StoryboardRendererAudioService,
    AlertService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts